import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home/home.vue'
import shop from '../views/shop/shop.vue'
import about from '../views/about/about.vue'
import cart from '../views/cart/cart.vue'
import service from '../views/service/service.vue'
import news from '../views/news/news.vue'
import login from '../views/login/login.vue'

import productview from '../views/productview/productview.vue'
import team from '../views/team/team.vue'
// import classs from '../views/classs/classs.vue'

const routerRePush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}


// import home2 from '../views/home/home2.vue'
// import service from '../views/service/service.vue'
// import curriculum from '../views/curriculum/curriculum.vue'
// import teacher from '../views/teacher/teacher.vue'
Vue.use(Router)
// const VueRouterPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(to) {
//     return VueRouterPush.call(this, to).catch(err => err)
// }

// const originalReplace = Router.prototype.replace
// originalReplace.replace = function replace(location) {
// return originalReplace.call(this, location).catch(err => err)
// }

export default new Router({

  mode: 'hash',  //去掉url中的#npm
  routes: [
    {
      path: '/',
      name: 'home', 
      component: home
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/productview',
      name: 'productview',
      component: productview
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart
    },
    {
      path: '/team',
      name: 'team',
      component: team
    },
    
    
    {
      path: '/service',
      name: 'service',
      component: service
    },
    // {
    //   path: '/curriculum',
    //   name: 'curriculum',
    //   component: curriculum
    // },
    // {
    //   path: '/teacher',
    //   name: 'teacher',
    //   component: teacher
    // }
  ],
  scrollBehavior(to,form,savedPosition){
    return { x:0 ,y:0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js